module.exports = __webpack_public_path__ + "static/header-image-07-3c046557f5c7c2f4dbc923441ecf27ee.png";